function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "63",
  height: "63",
  viewBox: "0 0 63 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.75C0 .783.783 0 1.75 0h9.1v3.5H3.5v7.35H0v-9.1zM22.05 0h18.199v3.5h-18.2V0zm29.398 0h9.1c.967 0 1.75.783 1.75 1.75v9.1h-3.5V3.5h-7.35V0zM3.5 22.05v18.199H0v-18.2h3.5zm58.798 0v18.199h-3.5v-18.2h3.5zM3.5 51.447v7.35h7.35v3.5h-9.1A1.75 1.75 0 010 60.548v-9.1h3.5zm58.798 0v9.1a1.75 1.75 0 01-1.75 1.75h-9.1v-3.5h7.35v-7.35h3.5zm-40.249 7.35h18.2v3.5h-18.2v-3.5z",
  fill: "#12002D",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.556 25.781c.642 0 1.162-.522 1.162-1.165 0-.644-.52-1.166-1.162-1.166-.642 0-1.162.522-1.162 1.166 0 .643.52 1.165 1.162 1.165z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.556 24.15a.464.464 0 00-.462.465c0 .26.21.465.462.465a.464.464 0 00.462-.465.464.464 0 00-.462-.466zm-1.862.465c0-1.028.832-1.866 1.862-1.866 1.03 0 1.862.838 1.862 1.866a1.864 1.864 0 01-1.862 1.865 1.864 1.864 0 01-1.862-1.865z",
  fill: "#180F2B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.966 25.781c.642 0 1.162-.522 1.162-1.165 0-.644-.52-1.166-1.162-1.166-.641 0-1.162.522-1.162 1.166 0 .643.52 1.165 1.162 1.165z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.966 24.15a.464.464 0 00-.462.465c0 .26.21.465.462.465a.464.464 0 00.462-.465.464.464 0 00-.462-.466zm-1.861.465c0-1.028.83-1.866 1.861-1.866 1.03 0 1.862.838 1.862 1.866a1.864 1.864 0 01-1.862 1.865 1.864 1.864 0 01-1.861-1.865z",
  fill: "#180F2B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.55 30.905c0 1.522.602 2.98 1.673 4.054a5.695 5.695 0 004.034 1.677 5.695 5.695 0 004.033-1.677 5.742 5.742 0 001.674-4.054h2.8c0 2.261-.896 4.43-2.49 6.03a8.495 8.495 0 01-6.017 2.5c-2.258 0-4.422-.899-6.017-2.5a8.543 8.543 0 01-2.49-6.03h2.8z",
  fill: "#12002D"
})));